Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    toggleForegroundColorDefault: tokens.themeInkDefault,
    toggleForegroundColorDisabled: tokens.themeInkDisabled,
    toggleSpacingHorizontal: 12,
    toggleMotionDuration: "200ms",
    toggleMotionFunction: "ease",
    toggleTrackSpacingInset: 3,
    toggleTrackWidthSmall: 40,
    toggleTrackWidthMedium: 40,
    toggleTrackWidthLarge: 48,
    toggleTrackBorderWidth: 1,
    toggleTrackBorderRadius: 12,
    toggleTrackBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    toggleTrackBorderColorSelectedDisabled: tokens.themeBorderDisabled,
    toggleTrackBorderColorUnselectedDefault: tokens.themeBorderFormfield,
    toggleTrackBorderColorUnselectedDisabled: tokens.themeBorderDisabled,
    toggleTrackBackgroundColorSelectedDefault: tokens.themeActionPrimaryDefault,
    toggleTrackBackgroundColorSelectedHover: tokens.themeActionPrimaryHover,
    toggleTrackBackgroundColorSelectedPressed: tokens.themeActionPrimaryPressed,
    toggleTrackBackgroundColorSelectedDisabled: tokens.themeActionPrimaryDisabledSubdued,
    toggleTrackBackgroundColorUnselectedDefault: tokens.themePageDefault,
    toggleTrackBackgroundColorUnselectedHover: tokens.themeActionNeutralHover,
    toggleTrackBackgroundColorUnselectedPressed: tokens.themeActionNeutralPressed,
    toggleTrackBackgroundColorUnselectedDisabled: tokens.themeActionNeutralDisabled,
    toggleBallBorderRadius: 999,
    toggleBallDropShadowHoverPressedOffsetX: 0,
    toggleBallDropShadowHoverPressedOffsetY: 1,
    toggleBallDropShadowHoverPressedBlur: 2,
    toggleBallDropShadowHoverPressedSpread: 0,
    toggleBallDropShadowHoverPressedColor: "#02080E",
    toggleBallDropShadowHoverPressedOpacity: 16,
    toggleBallBackgroundColorSelectedDefault: tokens.themeInkInverse,
    toggleBallBackgroundColorSelectedDisabled: tokens.themeInkInverse,
    toggleBallBackgroundColorUnselectedDefault: tokens.themeInkSubdued,
    toggleBallBackgroundColorUnselectedDisabled: tokens.themeInkDisabled,
    toggleBallDiameterSmall: 12,
    toggleBallDiameterMedium: 12,
    toggleBallDiameterLarge: 16,
    toggleIndicatorColorSelectedDefault: tokens.themeInkInverse,
    toggleIndicatorColorSelectedDisabled: tokens.themeActionNeutralDisabled,
    toggleIndicatorColorUnselectedDefault: "rgba(0, 0, 0, 0)",
    toggleIndicatorColorUnselectedHover: tokens.themeActionPrimaryDefault,
    toggleIndicatorColorUnselectedPressed: tokens.themeInkInverse
  }
};